// extracted by mini-css-extract-plugin
export default {"inclusive-content":"styles_inclusive-content__ArLwr"};